import { Snackbar, styled } from "@mui/material";
import { alertSnackName } from "../classes.js";
const Root = styled(Snackbar, {
  name: alertSnackName,
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root]
})(({ theme }) => ({
  display: "block",
  transform: "none",
  position: "static",
  [theme.breakpoints.up("sm")]: {
    transform: "none"
  }
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
